import translator from "@/translator";
import React from "react";
import BackButton from "@/note_office/shared/BackButton";
import BookingsMenu from "./components/BookingsMenu";
import { Typography } from "antd";
import ShareLinkCard from "@/note_office/shared/ShareLinkCard";

const { Text } = Typography;

const t = translator("note_office.views.bookings_menu.index_view.");

const IndexView = ({ bookingsMenuData }) => {
  const bookingLink = bookingsMenuData.booking_link;

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <BackButton link={bookingsMenuData.profile_url} text={t("title")} />

      <ShareLinkCard link={bookingLink} shareText={t("share_text")} />

      <div className="profile__menu-container overflow">
        <BookingsMenu bookingsMenuData={bookingsMenuData} />
      </div>
    </div>
  );
};

export default IndexView;
